import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useOfferRenderContext } from "./OfferRenderContext.js";
import { useOfferActionContext } from "./OfferActionContext.js";
export const LGPresetOfferActionProps = {
    buttonSlot: {
        type: "slot",
        displayName: "Button Slot",
    },
};
export function LGPresetOfferAction({ className, buttonSlot }) {
    const { offer } = useOfferRenderContext();
    const { selectOffer } = useOfferActionContext();
    const handleSelect = () => {
        // TODO: rest offerType cases
        if (offer?.offerType === "preset") {
            selectOffer?.({ offerKey: offer.preset });
        }
    };
    const buttonEl = buttonSlot &&
        React.cloneElement(buttonSlot, {
            id: "preset-offer-action",
            onClick: handleSelect,
        });
    return _jsx("div", { className: className, children: buttonEl || null });
}
